import { Skeleton } from "@/components/ui/skeleton";
import { ProjectView } from "@/components/project/ProjectView";
import { useGuestProject } from "@/hooks/useProjectStore";
import { guestApi } from "@/lib/api";

export default function GuestProject() {
  const store = useGuestProject();
  if (!store.project) return <Skeleton className="h-screen w-full rounded-none" data-testid="guest-project-loading" />;
  return <ProjectView {...store} api={guestApi} guest />;
}
